module.exports = __webpack_public_path__ + "0c052e67a0072fe3a8218b4ab70a1d82.svg";